import { Injectable, Output, EventEmitter, Directive } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';

import { AppConfig } from '../../../../app.config';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { EndCustomerInvoiceBasicInformation, NavigationLink } from '../../models/end-customer-invoice.model';


@Directive()
@Injectable({
    providedIn: 'root'
})
export class EndCustomerInvoiceBasicInformationService {

    private urlIwmBackendTask: string = this.config.backendIwmUri + 'Api/';
    private urlIwmBackend: string = this.config.backendIwmUri + 'EndCustomerInvoiceApi/';
    private urlBasicinfo: string = 'EndCustomerInvoices({0})';
    private urlTaskBasicinfo: string = 'Tasks({0})';


    constructor(private http: HttpClient, private config: AppConfig) { }

    public makeCreditNote(Id: string): Observable<any> {

        var urlMakeCreditNote = this.urlIwmBackend + 'EndCustomerInvoices/Default.CopyEndCustomerInvoiceAsCreditNote'
        return this.http.post(urlMakeCreditNote, { 'SourceEndCustomerInvoiceId': Id });
    }

    /**
       * Get end customer invoice by GUID
       * @param {string} id 
       * @returns {Observable<EndCustomerInvoiceBasicInformation>}
       */
    public getEndCustomerInvoice(id: string): Observable<EndCustomerInvoiceBasicInformation> {
        const url = this.urlIwmBackend + this.urlBasicinfo.replace('{0}', id);
        const ip = this.fetchData(url);
        return ip;
    }

    /**
  * Get End customer invoice
  * @param iwmId Iwm id
  */
    public getEndCustomerInvoiceById(iwmId: number): Observable<any> {
        const url = this.urlIwmBackend + `EndCustomerInvoices?$filter=IwmId eq ${iwmId}`;
        return this.fetchData(url);
    }

    /**
       * Get task details by GUID
       * @param {string} id GUID task identifier
       * @returns {Observable<TaskBasicInfo>}
       */
    public getTaskBasicinfo(id: string): Observable<TaskBasicInfo> {
        const url = this.urlIwmBackendTask + this.urlTaskBasicinfo.replace('{0}', id);
        const task = this.fetchData(url);
        return task;
    }

    /**
     * Get payer customer
     * @param taskId id of the task
     */
    public getPayerCustomer(taskId: string): Observable<any> {
        const url = `${this.urlIwmBackendTask}TaskExternalPersons?$filter=TaskId eq ${taskId} and Role eq 'PayerCustomer'`;
        return this.fetchData(url);
    }

    public getTaskOwnerListItemsByType(taskId: string, type: string) {
        const url = `${this.config.backendIwmUri}CustomerAdminApi/ListItems/Default.GetListItemsByTypeAndTask(type=HeadPower.Iwm.Objects.Enum.ListType'${type}',taskId=${taskId})`;
        return this.fetchData(url);
    }

    /**
     * Get navigation link name for Task
     * @param id
     * @returns
     */
    public GetNavigationTaskLink(id: string): Observable<NavigationLink> {
        const url = `${this.urlIwmBackendTask}Tasks(${id})?$select=TaskId,Identifier,Name`;
        return this.http.get<NavigationLink>(url)
            .pipe(catchError(this.handleError(null))); // user may not have access to Task
    }

    /**
     * Update end customer invoice
     * @param {string} Id Id of the End customer invoice
     * @param {EndCustomerInvoiceBasicInformation} basicInfo EndCustomerInvoice object
     * @returns {Observable<boolean>}
     */
    public update(Id: string, basicInfo: Partial<EndCustomerInvoiceBasicInformation>): Observable<any> {
        const url = this.urlIwmBackend + this.urlBasicinfo.replace('{0}', Id);
        return this.http.patch(url, basicInfo);
    }


    /**
    * Fetch data from oData endpoints
    * @param {string} url Resource url
    * @returns {Observable<any>}
    */
    private fetchData(url: string): Observable<any> {
        return this.http.get(url);
    }

    /**
   * Handling error statuscodes 
   */
    private handleError(errorResponse: any) {
        return (err: any) => {
            if (err instanceof HttpErrorResponse && (err.status === 403)) {
                return of(errorResponse);
            }
            else {
                return throwError(() => err);
            }
        }
    }

}

export class TaskBasicInfo {
    Id: string;
    TaxType: number;
}

